import { memo, useMemo } from 'react';

import { Form } from '@components/form';
import { useLocale } from '@locale/translate';

import { postalCodeOptionsMap } from './postal-codes';
import { DropdownField, SelectMultiField } from './types';
import { getTranslatedFormText } from './utils';

export const SelectInput = memo<{ field: DropdownField }>(({ field }) => {
  const currentLanguage = useLocale();

  const options = useMemo(() => {
    if (field.predef) {
      const predefOptions = postalCodeOptionsMap[field.predef];
      if (predefOptions) {
        return predefOptions;
      }
    }

    return (field.options ?? []).map(({ display: label, value, helpText }) => ({
      label: getTranslatedFormText(label, currentLanguage),
      value,
      helpText: getTranslatedFormText(helpText, currentLanguage),
    }));
  }, [currentLanguage, field.options, field.predef]);

  return (
    <Form.Select
      {...field}
      label={getTranslatedFormText(field.text, currentLanguage)}
      options={options}
      defaultValue={field.value}
    />
  );
});

export const SelectMultiInput = memo<{ field: SelectMultiField }>(({ field }) => {
  const currentLanguage = useLocale();

  const options = useMemo(() => {
    if (field.predef) {
      const predefOptions = postalCodeOptionsMap[field.predef];
      if (predefOptions) {
        return predefOptions;
      }
    }

    return (field.options ?? []).map(({ label, value, helpText }) => ({
      label: getTranslatedFormText(label, currentLanguage),
      value,
      helpText: getTranslatedFormText(helpText, currentLanguage),
    }));
  }, [currentLanguage, field.options, field.predef]);

  return (
    <Form.SelectMulti
      {...field}
      label={getTranslatedFormText(field.text, currentLanguage)}
      options={options}
      defaultValue={field.value}
    />
  );
});
